class ErrorHandler {
  constructor() {
    this.id = null;
    this.code = null;
    this.quoteId = null;
    this.message = null;
  }
}
export default ErrorHandler;
